module.exports = __webpack_public_path__ + "static/img/bgblue.1285f27b.png";